/**
 * Collection Filters V2 - NO PAGE RELOAD
 * Handles filtering with AJAX to avoid page refresh
 */

(function() {
  'use strict';

  const FiltersV2 = {
    selectors: {
      container: '[data-filters-v2]',
      sidebar: '[data-filters-sidebar]',
      overlay: '[data-filters-overlay]',
      toggle: '[data-filters-toggle]',
      close: '[data-filters-close]',
      form: '[data-filters-form]',
      input: '[data-filter-input]',
      productsGrid: '[data-products-grid]',
      productCount: '.collection-header__count',
      pagination: '.collection-pagination',
      loadMore: '[data-load-more-container]'
    },

    init: function() {
      this.container = document.querySelector(this.selectors.container);
      if (!this.container) return;

      this.isAjax = this.container.dataset.ajax === 'true';
      this.sidebar = this.container.querySelector(this.selectors.sidebar);
      this.overlay = this.container.querySelector(this.selectors.overlay);
      this.form = this.container.querySelector(this.selectors.form);

      this.bindEvents();

      console.log('✅ Filters V2 initialized - AJAX:', this.isAjax);
    },

    bindEvents: function() {
      // Mobile toggle
      const toggleBtn = document.querySelector(this.selectors.toggle);
      if (toggleBtn) {
        toggleBtn.addEventListener('click', () => this.openSidebar());
      }

      // Close button
      const closeBtn = this.sidebar.querySelector(this.selectors.close);
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.closeSidebar());
      }

      // Overlay click
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.closeSidebar());
      }

      // Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.sidebar.classList.contains('is-open')) {
          this.closeSidebar();
        }
      });

      // Form submission
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.applyFilters();
        });

        // Auto-apply on checkbox change (if AJAX enabled)
        if (this.isAjax) {
          const checkboxes = this.form.querySelectorAll('input[type="checkbox"]');
          checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => {
              this.applyFilters();
            });
          });
        }
      }

      // Active filter tags (remove filter)
      document.querySelectorAll('.filters-v2__active-tag').forEach(tag => {
        tag.addEventListener('click', (e) => {
          if (this.isAjax) {
            e.preventDefault();
            this.fetchAndUpdate(tag.href);
          }
        });
      });

      // Clear all
      const clearAll = document.querySelector('.filters-v2__clear-all');
      if (clearAll && this.isAjax) {
        clearAll.addEventListener('click', (e) => {
          e.preventDefault();
          this.fetchAndUpdate(clearAll.href);
        });
      }
    },

    openSidebar: function() {
      this.sidebar.classList.add('is-open');
      this.overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    },

    closeSidebar: function() {
      this.sidebar.classList.remove('is-open');
      this.overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    },

    applyFilters: function() {
      if (!this.isAjax) {
        // Non-AJAX: just submit the form normally
        this.form.submit();
        return;
      }

      // AJAX: Build URL from form inputs
      const formData = new FormData(this.form);
      const url = new URL(window.location.href);

      // Clear existing filter params (but keep sort and page params)
      const params = new URLSearchParams(url.search);
      const sortBy = params.get('sort_by');

      // Remove all existing params
      url.search = '';
      const newParams = new URLSearchParams();

      // Keep sort param if exists
      if (sortBy) {
        newParams.set('sort_by', sortBy);
      }

      // Add new filter params from checked checkboxes
      const checkboxes = this.form.querySelectorAll('input[type="checkbox"]:checked');
      checkboxes.forEach(checkbox => {
        newParams.append(checkbox.name, checkbox.value);
      });

      // Add price range params if set
      const priceInputs = this.form.querySelectorAll('input[type="number"]');
      priceInputs.forEach(input => {
        if (input.value && input.value.trim() !== '') {
          newParams.set(input.name, input.value);
        }
      });

      url.search = newParams.toString();
      console.log('🔍 Filter URL:', url.toString());
      this.fetchAndUpdate(url.toString());
    },

    fetchAndUpdate: function(url) {
      console.log('🔍 Fetching:', url);
      this.setLoading(true);

      fetch(url)
        .then(response => {
          console.log('🔍 Response status:', response.status);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then(html => {
          console.log('🔍 HTML received, length:', html.length);
          this.updatePage(html, url);
          this.setLoading(false);
        })
        .catch(error => {
          console.error('🔍 Filter error:', error);
          this.setLoading(false);
          // Fallback: navigate normally
          window.location.href = url;
        });
    },

    updatePage: function(html, url) {
      console.log('🔍 Updating page...');
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update products grid
      const newGrid = doc.querySelector(this.selectors.productsGrid);
      const currentGrid = document.querySelector(this.selectors.productsGrid);
      console.log('🔍 Products grid - New:', !!newGrid, 'Current:', !!currentGrid);
      if (newGrid && currentGrid) {
        console.log('🔍 Updating products grid with', newGrid.children.length, 'items');
        currentGrid.innerHTML = newGrid.innerHTML;
      } else {
        console.error('🔍 Could not find products grid!');
      }

      // Update filters sidebar
      const newFilters = doc.querySelector(this.selectors.sidebar);
      console.log('🔍 Filters sidebar - New:', !!newFilters, 'Current:', !!this.sidebar);
      if (newFilters && this.sidebar) {
        const wasOpen = this.sidebar.classList.contains('is-open');
        console.log('🔍 Updating filters sidebar, was open:', wasOpen);
        this.sidebar.innerHTML = newFilters.innerHTML;
        if (wasOpen) {
          this.sidebar.classList.add('is-open');
        }
        // Re-bind events on new sidebar
        this.bindSidebarEvents();
      }

      // Update product count
      const newCount = doc.querySelector(this.selectors.productCount);
      const currentCount = document.querySelector(this.selectors.productCount);
      if (newCount && currentCount) {
        currentCount.innerHTML = newCount.innerHTML;
      }

      // Update pagination
      const newPagination = doc.querySelector(this.selectors.pagination);
      const currentPagination = document.querySelector(this.selectors.pagination);
      if (currentPagination) {
        if (newPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
        } else {
          currentPagination.remove();
        }
      }

      // Update Load More.
      // Without this the button keeps the data-next-url of the UNFILTERED
      // result set, so clicking it appends page 2 of the whole collection on
      // top of the filtered grid -- which reads to a shopper as "the filter
      // isn't working". The button's click handler is delegated from the
      // section (collection-page.js), so replacing the markup here is safe.
      const newLoadMore = doc.querySelector(this.selectors.loadMore);
      const currentLoadMore = document.querySelector(this.selectors.loadMore);
      if (currentLoadMore) {
        currentLoadMore.innerHTML = newLoadMore
          ? newLoadMore.innerHTML
          : '<p class="collection-load-more__status">All products loaded</p>';
      }

      // Update URL without reload
      history.pushState({}, '', url);

      // Scroll to top of products
      const collectionMain = document.querySelector('.collection-main');
      if (collectionMain) {
        const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
        const top = collectionMain.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      // Close mobile sidebar after applying
      if (window.innerWidth <= 768) {
        this.closeSidebar();
      }

      // Re-initialize product card animations if available
      if (window.Rutambhara && window.Rutambhara.AnimateOnScroll) {
        window.Rutambhara.AnimateOnScroll.initProductCards();
      }
    },

    bindSidebarEvents: function() {
      console.log('🔍 Re-binding sidebar events');

      // Re-bind form submission
      const form = this.sidebar.querySelector('[data-filters-form]');
      if (form) {
        this.form = form;
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.applyFilters();
        });
      }

      // Re-bind checkbox auto-apply
      if (this.isAjax && this.form) {
        const checkboxes = this.form.querySelectorAll('input[type="checkbox"]');
        console.log('🔍 Re-binding', checkboxes.length, 'checkboxes');
        checkboxes.forEach(checkbox => {
          checkbox.addEventListener('change', () => {
            console.log('🔍 Checkbox changed:', checkbox.name, checkbox.value, checkbox.checked);
            this.applyFilters();
          });
        });
      }

      // Re-bind active filter tags
      this.sidebar.querySelectorAll('.filters-v2__active-tag').forEach(tag => {
        tag.addEventListener('click', (e) => {
          if (this.isAjax) {
            e.preventDefault();
            this.fetchAndUpdate(tag.href);
          }
        });
      });

      // Re-bind clear all button
      const clearAll = this.sidebar.querySelector('.filters-v2__clear-all');
      if (clearAll && this.isAjax) {
        clearAll.addEventListener('click', (e) => {
          e.preventDefault();
          this.fetchAndUpdate(clearAll.href);
        });
      }
    },

    setLoading: function(isLoading) {
      const grid = document.querySelector(this.selectors.productsGrid);
      if (grid) {
        if (isLoading) {
          grid.style.opacity = '0.5';
          grid.style.pointerEvents = 'none';
        } else {
          grid.style.opacity = '1';
          grid.style.pointerEvents = '';
        }
      }
    }
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => FiltersV2.init());
  } else {
    FiltersV2.init();
  }

  // Reinitialize on Shopify section reload
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-filters-v2]')) {
      FiltersV2.init();
    }
  });

  // Make globally available
  window.Rutambhara = window.Rutambhara || {};
  window.Rutambhara.FiltersV2 = FiltersV2;
})();
